<template>
  <div class="systemManage-create create-image">
    <el-dialog
      v-model="dialogVisible"
      :title="$t('lcd.Devices.Device Details')"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <el-descriptions>
        <el-descriptions-item :label="$t('lcd.Devices.Device ID')">{{
          detailData.code
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lcd.Devices.Store Name')">{{
          detailData.storeName
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lcd.Devices.Device Status')">
          <el-tag
            v-if="detailData.onlineState == 4201"
            type="success"
            size="small"
            >{{ detailData.onlineStateDesc }}</el-tag
          >
          <el-tag v-else size="small" type="danger">{{
            detailData.onlineStateDesc
          }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lcd.Devices.Signal Strength')">
          {{ detailData.signalStrength }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lcd.Devices.Resolution')">{{
          detailData.pixels
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lcd.Devices.Bind Status')">{{
          detailData.stateDesc
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lcd.Devices.Device Start Time')">{{
          detailData.onTime
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lcd.Devices.Device End Time')">{{
          detailData.offTime
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lcd.Devices.Last Heart')">{{
          detailData.heartBeatTime
        }}</el-descriptions-item>
        <el-descriptions-item label="MAC">
          {{ detailData.macAddress }}
        </el-descriptions-item>
        <el-descriptions-item label="IP">
          {{ detailData.ipAddress }}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "device-detail",
  components: {},
  props: {
    detailData: {
      type: Object,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      dialogVisible: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 打开弹窗
    open() {
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.systemManage-create.create-image {
  .form-box {
    width: 500px;
  }
  .file-list {
    display: flex;
  }
  .form-btn-section {
    margin-top: 0px;
  }
  .el-select,
  .el-input--small {
    width: 82%;
    margin-right: 10px;
  }
  ::v-deep .el-tag {
    margin-bottom: 10px;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    padding-right: 30px;
    // word-wrap: break-word;
    // word-break: break-all;
    .el-icon-close {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.select-group {
  .table-icon {
    padding: 6px;
    cursor: pointer;
    font-size: 18px;
    color: #000;
  }
}
</style>